import { ComponentType } from "react";

import { RollForwardWizardStep } from "./roll_forward_wizard.constants";
import { RollForwardWizardState } from "./roll_forward_wizard_store";
import { ContinuityAndDatesStep } from "./steps/continuity_dates_step/continuity_dates_step";
import { FiltersStep } from "./steps/filters_step/filters_step";
import { SourceTargetStep } from "./steps/source_target_step/source_target_step";
import { SummaryStep } from "./steps/summary_step/summary_step";

type RollForwardWizardStepTitleKey =
  | "steps.filters"
  | "steps.sourceTarget"
  | "steps.continuityAndDates"
  | "steps.summary";

type RollForwardWizardStepSubtitleKey =
  | "subtitles.filters"
  | "subtitles.sourceTarget"
  | "subtitles.continuityAndDates"
  | "subtitles.summary";

type RollForwardWizardStepConfig = {
  titleKey: RollForwardWizardStepTitleKey;
  subtitleKey: RollForwardWizardStepSubtitleKey;
  qaId: string;
  Component: ComponentType;
  isComplete: (state: RollForwardWizardState) => boolean;
};

export const ROLL_FORWARD_WIZARD_STEPS: Record<RollForwardWizardStep, RollForwardWizardStepConfig> = {
  [RollForwardWizardStep.Filters]: {
    titleKey: "steps.filters",
    subtitleKey: "subtitles.filters",
    qaId: "RollForwardWizard.Progress.FiltersStep",
    Component: FiltersStep,
    // TODO: [SP-11833] derive Filters step completeness from the filters slice
    isComplete: () => true
  },
  [RollForwardWizardStep.SourceTarget]: {
    titleKey: "steps.sourceTarget",
    subtitleKey: "subtitles.sourceTarget",
    qaId: "RollForwardWizard.Progress.SourceTargetStep",
    Component: SourceTargetStep,
    // TODO: [SP-11686] derive Source and Target step completeness from the sourceTarget slice
    isComplete: () => true
  },
  [RollForwardWizardStep.ContinuityAndDates]: {
    titleKey: "steps.continuityAndDates",
    subtitleKey: "subtitles.continuityAndDates",
    qaId: "RollForwardWizard.Progress.ContinuityAndDatesStep",
    Component: ContinuityAndDatesStep,
    // TODO: [SP-11687] derive Continuity and dates step completeness from the continuity slice
    isComplete: () => true
  },
  [RollForwardWizardStep.Summary]: {
    titleKey: "steps.summary",
    subtitleKey: "subtitles.summary",
    qaId: "RollForwardWizard.Progress.SummaryStep",
    Component: SummaryStep,
    // TODO: [SP-11688] derive Summary step completeness
    isComplete: () => true
  }
};
